import { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MUICheckbox from '@material-ui/core/Checkbox';
import { color } from '../../app/theme';

const useStyles = theme => ({
  root: ({ width, height }) => ({
    ...theme.checkbox.root,
    color: color.$10,
    '& .MuiIconButton-label > svg': {
      width,
      height,
    },
  }),
  colorPrimary: theme.checkbox.colorPrimary,
  checked: {
    '&:hover': {
      backgroundColor: 'transparent!important',
    },
  },
});

class Checkbox extends Component {
  render() {
    const {
      props: {
        onChange,
        checked,
        className,
        classes,
        inputRef,
        style,
        ...otherProps
      },
    } = this;

    return (
      <MUICheckbox
        classes={{
          root: classes.root,
        }}
        disableRipple
        inputRef={inputRef}
        className={className}
        style={style}
        checked={checked}
        onChange={onChange}
        color="primary"
        {...otherProps}
      />
    );
  }
}

Checkbox.defaultProps = {
  width: 24,
  height: 24,
};

Checkbox.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default withStyles(useStyles, { name: 'MuiCheckbox' })(Checkbox);
